export default __webpack_public_path__ + "static/media/Hz528.5f0b4a87.mp3";